import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  customerVulnerabilityScans: [],
  nessusScans: [],
  attachScanToAssessment: {},
  assessmentScan: [],
  scanVulnerabilities: [],
  highVulnerabilities: [],
  mediumVulnerabilities: [],
  lowVulnerabilities: [],
  infoVulnerabilities: [],
  updateSeverityByIP: {},
  criticalVulnerabilities: [],
  updateRemediationAndComments: {},
  engineersAssignedVulnerabilities: [],
  critical: [],
  high: [],
  remediateIP: {},
  assignUser: {},
  isLoading: false,
  remediateIPFalsePositive: {},
  vulnerabilityByPluginID: {},
  multipleScanVulnerabilities: {},
  remediationActionToggle: false,
  vulnerabilityUrl: '',
  error: [],
  findbyrackSection: [],
  // states for new reducers
  requestAssistanceForVulnerability: null,
  reportQueueAssessment: [],
};

const vulnerabilityScanSlice = createSlice({
  name: 'vulnerabilityScan',
  initialState,
  reducers: {
    start: (state, action) => {
      state.isLoading = true;
    },
    setReducerError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    setReportQueueAssessment: (state, action) => {
      state.reportQueueAssessment = action.payload;
      state.isLoading = false;
    },
    setAssignUser: (state, action) => {
      state.assignUser = action.payload;
      state.isLoading = false;
    },
    setEngineersAssignedVulnerabilities: (state, action) => {
      state.engineersAssignedVulnerabilities = action.payload;
      state.isLoading = false;
    },
    setInfoVulnerabilities: (state, action) => {
      state.infoVulnerabilities = action.payload;
      state.isLoading = false;
    },
    setLowVulnerabilities: (state, action) => {
      state.lowVulnerabilities = action.payload;
      state.isLoading = false;
    },
    setMediumVulnerabilities: (state, action) => {
      state.mediumVulnerabilities = action.payload;
      state.isLoading = false;
    },
    setHighVulnerabilities: (state, action) => {
      state.highVulnerabilities = action.payload;
      state.isLoading = false;
    },
    setCriticalVulnerabilities: (state, action) => {
      state.criticalVulnerabilities = action.payload;
      state.isLoading = false;
    },
    setVulnerabilityByPluginID: (state, action) => {
      state.vulnerabilityByPluginID = action.payload;
      state.isLoading = false;
    },
    setFindByRackSection: (state, action) => {
      state.findbyrackSection = action.payload; // state not found
      state.isLoading = false;
    },
    setCustomerVulnerabilityScans: (state, action) => {
      state.customerVulnerabilityScans = action.payload;
      state.isLoading = false;
    },
    setCritical: (state, action) => {
      state.critical = action.payload;
      state.isLoading = false;
    },
    setNessusScans: (state, action) => {
      state.nessusScans = action.payload;
      state.isLoading = false;
    },
    setAttachScanToAssessment: (state, action) => {
      state.attachScanToAssessment = action.payload;
      state.isLoading = false;
    },
    setAssessmentScan: (state, action) => {
      state.assessmentScan = action.payload;
      state.isLoading = false;
    },
    setScanVulnerabilities: (state, action) => {
      state.scanVulnerabilities = action.payload;
      state.isLoading = false;
    },
    setUpdateSeverityByIP: (state, action) => {
      state.updateSeverityByIP = action.payload;
      state.isLoading = false;
    },
    setUpdateRemediationAndComments: (state, action) => {
      state.updateRemediationAndComments = action.payload;
      state.isLoading = false;
    },
    setMultipleScanVulnerabilities: (state, action) => {
      state.multipleScanVulnerabilities = action.payload;
      state.isLoading = false;
    },
    setRemediateIP: (state, action) => {
      state.remediateIP = action.payload;
      state.isLoading = false;
    },
    setRemediationActionToggle: (state, action) => {
      state.remediationActionToggle = !state.remediationActionToggle;
    },
    setVulnerabilityUrlAction: (state, action) => {
      state.vulnerabilityUrl = action.payload;
      state.isLoading = false;
    },
    setRequestAssistanceForVulnerability: (state, action) => {
      state.requestAssistanceForVulnerability = action.payload;
      state.isLoading = false;
    },
    setResetVulnerability: () => {
      return initialState;
    },
  },
});

export const {
  start,
  setReducerError,
  setReportQueueAssessment,
  setAssignUser,
  setEngineersAssignedVulnerabilities,
  setInfoVulnerabilities,
  setLowVulnerabilities,
  setMediumVulnerabilities,
  setHighVulnerabilities,
  setCriticalVulnerabilities,
  setVulnerabilityByPluginID,
  setFindByRackSection,
  setCustomerVulnerabilityScans,
  setCritical,
  setNessusScans,
  setAttachScanToAssessment,
  setAssessmentScan,
  setScanVulnerabilities,
  setUpdateSeverityByIP,
  setUpdateRemediationAndComments,
  setMultipleScanVulnerabilities,
  setRemediateIP,
  setRemediationActionToggle,
  setVulnerabilityUrlAction,
  // newly created reducers
  setRequestAssistanceForVulnerability,
  setResetVulnerability,
} = vulnerabilityScanSlice.actions;

export default vulnerabilityScanSlice.reducer;
